import React, { useState, useEffect } from 'react';
import wrapStore from '@src/utils/wrap-store';
import ArticleStore from './store';
import Link from '@src/components/link';
import cx from 'classnames';
import xauCss from '@src/components/xfe-animation-css';

const styles = require('./index.less');

const Article1 = ({ store }) => {
  store.use();
  const [activeAnchor, setActiveAnchor] = useState('');
  const [showSidebar, setShowSidebar] = useState(false);

  const scrollToAnchor = anchorId => {
    const element = document.getElementById(anchorId);
    if (element) {
      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
      const offset = 50; // 向上的偏移值
      window.scrollTo({ top: elementTop - offset, behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    const anchors = [
      '背景介绍',
      '开篇',
      '锤明教',
      '剑明教',
      '解控调整',
      '翠烟',
      '段氏',
      '峨嵋',
      '少林',
      '天王',
      '霸刀',
      '五毒',
      '天忍',
      '丐帮',
      '逍遥',
      '千机',
      '武当',
      '一品堂',
      '其他调整'
    ];
    const handleScroll = () => {
      let currentActive = '';
      for (const id of anchors) {
        const element = document.getElementById(id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 200) {
            currentActive = id;
          }
        }
      }
      setActiveAnchor(currentActive);

      const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
      const threshold = (960 / 192) * rootFontSize;
      setShowSidebar(window.scrollY >= threshold);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={styles.article}>
      <div className="xfe-root-article" data-name="内容">
        <div className={cx('xfe-group-2', { ...xauCss.FADE.IN_UP() })} data-name="顶部导航条">
          <div className="xfe-layer-3" />
          <div className="xfe-group-3" data-name="组 81">
            <Link className="xfe-layer-4" data-id={'背景介绍'} onClick={() => scrollToAnchor('背景介绍')} />
            <Link className="xfe-layer-5" data-id={'开篇'} onClick={() => scrollToAnchor('开篇')} />
            <Link className="xfe-layer-6" data-id={'锤明教'} onClick={() => scrollToAnchor('锤明教')} />
            <Link className="xfe-layer-7" data-id={'剑明教'} onClick={() => scrollToAnchor('剑明教')} />
            <Link className="xfe-layer-8" data-id={'解控调整'} onClick={() => scrollToAnchor('解控调整')} />
            <Link className="xfe-layer-9" data-id={'其他调整'} onClick={() => scrollToAnchor('其他调整')} />
          </div>
        </div>

        <div className={cx('page-1-group-1', { visible: showSidebar })} data-name="侧栏导航">
          <div className="page-1-layer-5" data-name="组 75" />
          <div className="page-1-group-2" data-name="组 35">
            <Link className={cx('page-1-group-3', { active: activeAnchor === '背景介绍' })} data-name="背景介绍" onClick={() => scrollToAnchor('背景介绍')}>
              <div className="page-1-layer-6" data-name="背景介绍" />
              <div className="page-1-layer-7" data-name="组 80" />
            </Link>

            <Link className={cx('page-1-group-4', { active: activeAnchor === '开篇' })} data-name="开篇" onClick={() => scrollToAnchor('开篇')}>
              <div className="page-1-layer-8" data-name="开篇" />
              <div className="page-1-layer-9" data-name="组 80" />
            </Link>

            <Link className={cx('page-1-group-5', { active: activeAnchor === '锤明教' })} data-name="锤明教" onClick={() => scrollToAnchor('锤明教')}>
              <div className="page-1-layer-10" data-name="锤明教" />
              <div className="page-1-layer-11" data-name="组 80 拷贝 2" />
            </Link>

            <Link className={cx('page-1-group-6', { active: activeAnchor === '剑明教' })} data-name="剑明教" onClick={() => scrollToAnchor('剑明教')}>
              <div className="page-1-layer-12" data-name="剑明教" />
              <div className="page-1-layer-13" data-name="组 80 拷贝 4" />
            </Link>

            <Link className={cx('page-1-group-7', { active: activeAnchor === '解控调整' })} data-name="解控调整" onClick={() => scrollToAnchor('解控调整')}>
              <div className="page-1-layer-14" data-name="解控调整" />
              <div className="page-1-layer-15" data-name="组 80 拷贝 5" />
            </Link>

            <Link className={cx('page-1-group-8', { active: activeAnchor === '翠烟' })} data-name="翠烟" onClick={() => scrollToAnchor('翠烟')}>
              <div className="page-1-layer-16" data-name="【翠烟】" />
              <div className="page-1-layer-17" data-name="组 80 拷贝11" />
            </Link>

            <Link className={cx('page-1-group-9', { active: activeAnchor === '段氏' })} data-name="段氏" onClick={() => scrollToAnchor('段氏')}>
              <div className="page-1-layer-18" data-name="【段氏】" />
              <div className="page-1-layer-19" data-name="组 80 拷贝11" />
            </Link>

            <Link className={cx('page-1-group-10', { active: activeAnchor === '峨嵋' })} data-name="峨嵋" onClick={() => scrollToAnchor('峨嵋')}>
              <div className="page-1-layer-20" data-name="【峨嵋】" />
              <div className="page-1-layer-21" data-name="组 80" />
            </Link>

            <Link className={cx('page-1-group-11', { active: activeAnchor === '少林' })} data-name="少林" onClick={() => scrollToAnchor('少林')}>
              <div className="page-1-layer-22" data-name="【少林】" />
              <div className="page-1-layer-23" data-name="组 80" />
            </Link>

            <Link className={cx('page-1-group-12', { active: activeAnchor === '天王' })} data-name="天王" onClick={() => scrollToAnchor('天王')}>
              <div className="page-1-layer-24" data-name="【天王】" />
              <div className="page-1-layer-25" data-name="组 80 拷贝 2" />
            </Link>

            <Link className={cx('page-1-group-13', { active: activeAnchor === '霸刀' })} data-name="霸刀" onClick={() => scrollToAnchor('霸刀')}>
              <div className="page-1-layer-26" data-name="【霸刀】" />
              <div className="page-1-layer-27" data-name="组 80 拷贝 4" />
            </Link>

            <Link className={cx('page-1-group-14', { active: activeAnchor === '五毒' })} data-name="五毒" onClick={() => scrollToAnchor('五毒')}>
              <div className="page-1-layer-28" data-name="【五毒】" />
              <div className="page-1-layer-29" data-name="组 80 拷贝 5" />
            </Link>

            <Link className={cx('page-1-group-15', { active: activeAnchor === '天忍' })} data-name="天忍" onClick={() => scrollToAnchor('天忍')}>
              <div className="page-1-layer-30" data-name="【天忍】" />
              <div className="page-1-layer-31" data-name="组 80 拷贝11" />
            </Link>

            <Link className={cx('page-1-group-16', { active: activeAnchor === '丐帮' })} data-name="丐帮" onClick={() => scrollToAnchor('丐帮')}>
              <div className="page-1-layer-32" data-name="【丐帮】" />
              <div className="page-1-layer-33" data-name="组 80 拷贝11" />
            </Link>

            <Link className={cx('page-1-group-17', { active: activeAnchor === '逍遥' })} data-name="逍遥" onClick={() => scrollToAnchor('逍遥')}>
              <div className="page-1-layer-34" data-name="【逍遥】" />
              <div className="page-1-layer-35" data-name="组 80" />
            </Link>

            <Link className={cx('page-1-group-18', { active: activeAnchor === '千机' })} data-name="千机" onClick={() => scrollToAnchor('千机')}>
              <div className="page-1-layer-36" data-name="【千机】" />
              <div className="page-1-layer-37" data-name="组 80 拷贝 2" />
            </Link>

            <Link className={cx('page-1-group-19', { active: activeAnchor === '武当' })} data-name="武当" onClick={() => scrollToAnchor('武当')}>
              <div className="page-1-layer-38" data-name="【武当】" />
              <div className="page-1-layer-39" data-name="组 80 拷贝 4" />
            </Link>

            <Link className={cx('page-1-group-20', { active: activeAnchor === '一品堂' })} data-name="一品堂" onClick={() => scrollToAnchor('一品堂')}>
              <div className="page-1-layer-40" data-name="【一品堂】" />
              <div className="page-1-layer-41" data-name="组 80 拷贝 5" />
            </Link>

            <Link className={cx('page-1-group-21', { active: activeAnchor === '其他调整' })} data-name="其他调整" onClick={() => scrollToAnchor('其他调整')}>
              <div className="page-1-layer-42" data-name="其他调整 拷贝 2" />
              <div className="page-1-layer-43" data-name="组 80 拷贝11" />
            </Link>

            <Link className="page-1-group-22" data-name="返回顶部" onClick={scrollToTop}>
              <div className="page-1-layer-44" data-name="返回顶部  拷贝 2" />
              <div className="page-1-layer-45" data-name="组 80 拷贝11" />
            </Link>
          </div>
        </div>
        <div className={cx('xfe-layer-26', { ...xauCss.FADE.IN_UP() })} />
        <div className={cx('xfe-group-content', { ...xauCss.FADE.IN_DOWN() })} data-name="内容区" dangerouslySetInnerHTML={{ __html: store.content }} />
      </div>
    </div>
  );
};

export default wrapStore(Article1, ArticleStore);
